<template>
  <div>

    <div class="space-y-6 mt-6">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        <div class="">
          <div class="flex gap-1 items-center">
            <label class="block text-sm font-medium text-gray-700">Contact First Name</label>
            <span class="relative group">
              <i class="fa fa-info-circle cursor-pointer text-xs text-indigo-500"></i>
              <div
                class="absolute bg-gray-900 bottom-6 group-hover:opacity-100 opacity-0 pointer-events-none px-3 py-4 rounded text-sm text-white tooltip-arrow-two transform w-96 z-100">
                <p class="text-xs font-bold text-white">
                  Contact name guidelines
                </p>
                <ul class="list-disc text-xs pl-3.5">
                  <li>Use the name we should call you by</li>
                  <li>Nicknames are ok</li>
                  <li>No need for a legal name</li>
                  <li>Avoid numbers or email addresses</li>
                </ul>
              </div>
            </span>
          </div>
          <input type="text" name="first_name" @blur="checkWarningValidation('first_name')" v-model="data.first_name"
            required placeholder="Name you go by" autocomplete="off" maxlength="50"
            class="placeholder:text-xs mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"
            :class="{ 'border-red-500': errors.first_name }" />

          <div class="text-red-600 text-xs px-1 py-1 items-start flex gap-1 " v-if="errors.first_name">
            <i class="fa fa-exclamation-triangle mt-0.5"></i>
            <span>{{ errors.first_name }}</span>
          </div>
          <div v-if="warnings.first_name" class="text-yellow-600 text-xs px-1 py-1 items-start flex gap-1">
            <span>{{ warnings.first_name }} </span>
          </div>
        </div>

        <div class="">
          <div class="flex gap-1 items-center">
            <label class="block text-sm font-medium text-gray-700"> Contact Last Name </label>
            <span class="relative group">
              <i class="fa fa-info-circle text-xs cursor-pointer text-indigo-500"></i>
              <div
                class="absolute bg-gray-900 bottom-6 group-hover:opacity-100 opacity-0 pointer-events-none px-3 py-4 rounded text-sm text-white tooltip-arrow-two transform w-96 z-100">
                <p class="text-xs font-bold text-white">Contact name guidelines</p>

                <ul class="list-disc text-xs pl-3.5">
                  <li>Use the name we should call you by</li>
                  <li>Nicknames are ok</li>
                  <li>No need for a legal name</li>
                  <li>Avoid numbers or email addresses</li>
                </ul>
              </div>
            </span>
          </div>
          <input type="text" name="last_name" @blur="checkWarningValidation('last_name')" v-model="data.last_name"
            required placeholder="Last name" autocomplete="off" maxlength="50"
            class="mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"
            :class="{ 'border-red-500': errors.last_name }" />

          <div class="text-red-600 text-xs px-1 py-1 items-start flex gap-1 " v-if="errors.last_name">
            <i class="fa fa-exclamation-triangle mt-0.5"></i>
            <span>{{ errors.last_name }}</span>
          </div>
          <div v-if="warnings.last_name" class="text-yellow-600 text-xs px-1 py-1 items-start flex gap-1">
            <span>{{ warnings.last_name }} </span>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        <div class="">
          <div class="flex gap-2 items-center">
            <label class="block text-sm font-medium text-gray-700">Cell Phone Number</label>
            <span class="text-gray-500 italic text-xs">(Used if we need to reach you about your protest)</span>
          </div>

          <v-the-mask mask="###-###-####" type="text" name="phone_number" v-model="data.phone_number" :masked=false
            placeholder="Enter phone number" autocomplete="off"
            class="mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"
            :class="{ 'border-red-500': errors.phone_number }" />


          <div class="text-red-600 text-xs px-1 py-1 items-start flex gap-1 " v-if="errors.phone_number">
            <i class="fa fa-exclamation-triangle mt-0.5"></i>
            <span>{{ errors.phone_number }}</span>
          </div>
        </div>

        <div class="">
          <label class="block text-sm font-medium text-gray-700"> How did you hear about us? </label>
          <select name='how_did_you_hear_about_us' v-model="data.how_did_you_hear_about_us"
            @change="showInputForOtherReason()" autocomplete="off" required
            class="mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            :class="{ 'border-red-500': errors.how_did_you_hear_about_us }">
            <option value="">Please Select</option>
            <option value="Facebook">Facebook</option>
            <option value="Nextdoor">Nextdoor</option>
            <option value="Word of Mouth">Word of Mouth</option>
            <option value="TV">TV</option>
            <option value="Google Ads">Google Ads</option>
            <option value="Postcard">Postcard</option>
            <option value="Live event">Live event</option>
            <option value="You helped me in the past">You helped me in the past</option>
            <option value="Other">Other</option>
          </select>

          <div class="text-red-600 text-xs px-1 py-1 items-start flex gap-1 " v-if="errors.how_did_you_hear_about_us">
            <i class="fa fa-exclamation-triangle mt-0.5"></i>
            <span> {{ errors.how_did_you_hear_about_us }}</span>
          </div>
        </div>
      </div>

      <div v-if="show_how_did_you_hear_about_us_other">
        <label class="block text-sm font-medium text-gray-700"> Let us know how you reached us </label>
        <input type="text" name="how_did_you_hear_about_us_other" maxlength="250"
          v-model="data.how_did_you_hear_about_us_other" placeholder="Please enter how you reached us"
          class="mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"
          :class="{ 'border-red-500': errors.how_did_you_hear_about_us_other }">

        <div class="text-red-600 text-xs px-1 py-1 items-start flex gap-1 "
          v-if="errors.how_did_you_hear_about_us_other">
          <i class="fa fa-exclamation-triangle mt-0.5"></i>
          <span>{{ errors.how_did_you_hear_about_us_other }}</span>
        </div>
      </div>

      <div class="mt-4 sm:mt-6 text-center border-t pt-4 sm:pt-6">
        <input type='button' value="Continue" :disabled="isProcessing" @click="submitHandler()"
          class="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
          :class="isProcessing ? 'bg-indigo-400 pointer-events-none' : 'bg-indigo-600'">
      </div>
    </div>
  </div>

</template>

<script>
import UserApi from "@/services/api/User.js";
export default {
  props: ["accountNumber", "email"],
  data() {
    return {
      data: {},
      show_how_did_you_hear_about_us_other: false,
      errors: {},
      warnings: {},
      isProcessing: false,
      warningTexts: ['LLC', 'L.L.C', 'INC', 'CORP', 'CORPORATION', 'Limited', 'LTD', 'L.T.D', 'TRUST', 'BANK', 'BANKING', 'COMPANY'],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.data = {
        ...this.data,
        ...{
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          how_did_you_hear_about_us: "",
          how_did_you_hear_about_us_other: "",
        },
      };
    },

    checkEmailExists() {
      this.$emit("check-email-exists", this.data.email);
    },

    showInputForOtherReason() {
      this.show_how_did_you_hear_about_us_other = false;

      if (this.data.how_did_you_hear_about_us == "Other") {
        this.show_how_did_you_hear_about_us_other = true;
      }
    },

    validateData() {
      var errors = {};
      let error = false;

      if (!this.data.first_name) {
        errors.first_name = "Please enter first name";
        error = true;
      }

      if (!this.data.last_name) {
        errors.last_name = "Please enter last name";
        error = true;
      }

      if (!this.data.email) {
        errors.email = "Please enter E-Mail";
        error = true;
      }

      if (!this.data.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        errors.email = "Please enter valid E-Mail";
        error = true;
      }

      if (!this.data.phone_number) {
        errors.phone_number = "Please enter phone number";
        error = true;
      }

      if (this.data.phone_number && this.data.phone_number.length !== 10) {
        errors.phone_number = "The phone number must be of 10 digits";
        error = true;
      }

      if (!this.data.how_did_you_hear_about_us) {
        errors.how_did_you_hear_about_us =
          "Please enter how did you hear about us";
        error = true;
      }

      if (
        this.data.how_did_you_hear_about_us == "Other" &&
        !this.data.how_did_you_hear_about_us_other
      ) {
        errors.how_did_you_hear_about_us_other =
          "Please specify the other mode by which you reached us";
        error = true;
      }

      this.errors = errors;

      return error;
    },
    checkWarningValidation(field) {
      const value = this.data[field]?.trim() || ''
      this.$delete(this.warnings, field);

      if (value.length === 1) {
        this.warnings = {
          ...this.warnings,
          [field]: 'You entered a single-letter value. Please confirm this is correct.'
        }
        return
      }

      for (const word of this.warningTexts) {
        const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const regex = new RegExp(`\\b${escaped}\\b`, 'i')

        if (regex.test(value)) {
          this.warnings = {
            ...this.warnings,
            [field]: `This value looks like a business name (${word}). Please confirm this is a personal name.`
          }
          return
        }
      }
    },

    submitHandler() {
      this.data.email = this.email;

      if (this.validateData()) return;

      this.isProcessing = true;

      const params = new URLSearchParams({
        intent: "register",
        email: this.data.email,
        accountNumber: this.accountNumber,
        first_name: this.data.first_name,
        last_name: this.data.last_name,
        phone_number: this.data.phone_number,
        how_did_you_hear_about_us: this.data.how_did_you_hear_about_us,
        how_did_you_hear_about_us_other: this.data.how_did_you_hear_about_us_other,
      });

      const url = `/oauth/popup-login?${params.toString()}`;
      window.location.href = url;

    },
  },
};
</script>
